import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import colors from "assets/theme/base/colors";

export const ClearFiltersButton = styled(Button)(({ theme }) => ({
    color: colors.secondary.main,
    textTransform: 'none',
    padding: '4px 8px',
    minWidth: 'unset',
    '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
    },
}));
